import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Live: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9999 12V12.01M14.8279 9.17199C15.5778 9.9221 15.9991 10.9393 15.9991 12C15.9991 13.0606 15.5778 14.0779 14.8279 14.828M17.6569 6.34299C18.3999 7.08586 18.9892 7.96779 19.3912 8.93842C19.7933 9.90906 20.0002 10.9494 20.0002 12C20.0002 13.0506 19.7933 14.0909 19.3912 15.0616C18.9892 16.0322 18.3999 16.9141 17.6569 17.657M9.16794 14.828C8.41806 14.0779 7.9968 13.0606 7.9968 12C7.9968 10.9393 8.41806 9.9221 9.16794 9.17199M6.33694 17.657C5.59403 16.9141 5.00472 16.0322 4.60266 15.0616C4.20059 14.0909 3.99365 13.0506 3.99365 12C3.99365 10.9494 4.20059 9.90906 4.60266 8.93842C5.00472 7.96779 5.59403 7.08586 6.33694 6.34299"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Live;
